import React, { useState, useEffect } from "react";
import { Tab, Nav } from "react-bootstrap";
import updateParams from "utils/updateParams.js";
import DailyView from "../views/DailyView";
import SummaryView from "../views/SummaryView";
import jsDig from "utils/jsDig";

export default function Social(props) {
  const [tabLocation, setTabLocation] = useState("");

  useEffect(() => {
    setTabLocation("summary");
    updateParams("sub_page", tabLocation);
  }, []);

  const selectTab = (key) => {
    setTabLocation(key);
    updateParams("sub_page", key);
  };

  const defaultMetrics = props.defaultMetrics

  return (
    <div className="styled-indent-blue">
      <div className="daily-or-summary ml-md-3 ml-0">
        <input hidden name="selected_page" value={tabLocation} readOnly />
        <Tab.Container id="ppc-pacing-tabs-2" defaultActiveKey="summary" activeKey={tabLocation} onSelect={(k) => selectTab(k)}>
          <Nav variant="pills" className="nav-fill tabs-navigation-2 row no-gutters row-cols-sm-1 row-cols-md-2 row-cols-lg-2">
            <Nav.Item className="col">
              <Nav.Link eventKey="summary" className="tab-titles sub-nav-item" data-link-type="page">
                <p className="">Summary</p>
              </Nav.Link>
            </Nav.Item>
            <Nav.Item className="col">
              <Nav.Link eventKey="daily" className="tab-titles sub-nav-item" data-link-type="page">
                Daily
              </Nav.Link>
            </Nav.Item>
          </Nav>
          <Tab.Content>
            <Tab.Pane eventKey="summary">
              <SummaryView
                service={props.service}
                pacingOrder={jsDig(["pacingOrder", "summary"], props) && props.pacingOrder.summary.length > 0 ? props.pacingOrder.summary : defaultMetrics.summary.social}
                defaultMetrics={defaultMetrics.summary.social}
                dateRanges={props.dateRanges}
                platforms={props.platforms}
                metricsData={props.metricsData}
                availableMetrics={props.availableMetrics}
                frequency={props.frequency}
              />
            </Tab.Pane>
            <Tab.Pane eventKey="daily">
              <DailyView
                dateRanges={props.dateRanges}
                pacingOrder={jsDig(["pacingOrder", "daily"], props) && props.pacingOrder.daily.length > 0 ? props.pacingOrder.daily : defaultMetrics.daily.social}
                defaultMetrics={defaultMetrics.daily.social}
                platforms={props.platforms}
                metricsData={props.metricsData}
                availableMetrics={props.availableMetrics}
                service={props.service}
              />
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
    </div>
  );
}
